import React from 'react'
import { useAtom } from 'jotai'
import Classnames from 'classnames'

// helper functions
import { returnValue } from '@/utils/op-types/helperFunctions'

// store
import {
  isBuilder,
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
} from '@/utils/op-types/store'

// block renderer
import BlockRenderer from '@/components/optypes/frontend/BlockRenderer'
import SocialLink from '@/components/optypes/frontend/LinkTree/SocialLink'
import LinkBlock from '@/components/optypes/frontend/LinkTree/LinkBlock'
import Header from '@/components/optypes/frontend/LinkTree/Header'

// block builder tools
import StaticContentWrapper from '@/components/optypes/frontend/StaticContentWrapper'
import AddBlockBuilder from '@/components/optypes/frontend/AddBlockBuilder'

const Components = {
  link_block: LinkBlock,
  header_block: Header,
}

// icons
import {
  RiYoutubeLine,
  RiFacebookBoxLine,
  RiInstagramLine,
  RiTwitterLine,
} from 'react-icons/ri'

const MainComponentRenderer = () => {
  const [builder] = useAtom(isBuilder)
  // manifest settings
  const [opStatic] = useAtom(manifestStatic)
  const [opDesign] = useAtom(manifestDesign)
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [pageStatic] = useAtom(pageContentStatic)
  const [pageDesign] = useAtom(pageContentDesign)
  const [pageBlocks] = useAtom(pageContentBlocks)

  function goToLink(link) {
    if (!builder) {
      if (link) {
        window.open(link, '_blank').focus()
      }
    }
  }

  return (
    <div
      className="min-h-screen	"
      style={{
        backgroundColor: returnValue('background_color', opDesign, pageDesign),
      }}
    >
      {/* BACKGROUND IMG */}
      <div
        className="fixed top-0 left-0 h-full w-full bg-cover bg-no-repeat"
        style={{
          opacity: returnValue('background_img_opacity', opDesign, pageDesign),
          backgroundImage: returnValue('background_img', opDesign, pageDesign)
            ? 'url(' + returnValue('background_img', opDesign, pageDesign) + ')'
            : '',
        }}
      ></div>

      <div className="container relative z-10 max-w-lg pt-12 mx-auto">
        {/* top area */}
        <div className="flex flex-col items-center">
          {/* avatar */}
          <div className="">
            <img
              src={returnValue('avatar_img', opStatic, pageStatic)}
              className="w-20 h-20 rounded-full"
            />
          </div>

          {/* tag & bio */}
          <div
            className="mt-6 mb-4"
            style={{
              color: returnValue('background_text_color', opDesign, pageDesign),
            }}
          >
            <h1 className="font-bold text-center">
              <StaticContentWrapper contentKey="social_tag">
                @{returnValue('social_tag', opStatic, pageStatic)}
              </StaticContentWrapper>
            </h1>
            <p className="text-center text-sm mt-2 px-16">
              <StaticContentWrapper contentKey="bio">
                {returnValue('bio', opStatic, pageStatic)}
              </StaticContentWrapper>
            </p>
          </div>
        </div>

        {/* LINKS */}
        <div className="my-6 space-y-3">
          {pageBlocks.map((block, index) => (
            <BlockRenderer
              key={index}
              index={index}
              Components={Components}
              block={block}
            />
          ))}

          <div className="flex items-center justify-center">
            {/* add block button builder */}
            {builder && (
              <AddBlockBuilder
                bgColor="bg-blue-600 hover:bg-blue-500"
                btnText="Add Link"
              />
            )}
          </div>
        </div>

        {/* SOCIAL ICONS */}
        <div
          style={{
            color: returnValue('background_text_color', opDesign, pageDesign),
          }}
          className="mt-4 flex items-center justify-center space-x-4 text-center"
        >
          {/* FACEBOOK */}
          {returnValue('facebook_url', opStatic, pageStatic) && (
            <SocialLink
              onClick={() => {
                goToLink(returnValue('facebook_url', opStatic, pageStatic))
              }}
              icon={<RiFacebookBoxLine />}
            />
          )}

          {/* YOUTUBE */}
          {returnValue('youtube_url', opStatic, pageStatic) && (
            <SocialLink
              onClick={() => {
                goToLink(returnValue('youtube_url', opStatic, pageStatic))
              }}
              icon={<RiYoutubeLine />}
            />
          )}

          {/* TWITTER */}
          {returnValue('twitter_url', opStatic, pageStatic) && (
            <SocialLink
              onClick={() => {
                goToLink(returnValue('twitter_url', opStatic, pageStatic))
              }}
              icon={<RiTwitterLine />}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default MainComponentRenderer
